import Util from "./Util.js";
//
import { gsap } from "./Util.js";
import { CustomEase } from "./Util.js";

class Hover extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.headerTab();
    if (window.website.page === "top" && window.website.isDesktop) {
      this.topStay();
    }
  }

  headerTab() {
    const tabHead = document.querySelectorAll("#header .tab-head");
    tabHead.forEach((target) => {
      target.addEventListener("click", () => {
        target.closest(".tab").classList.toggle("is-open");
      });
      // target.parentElement.querySelector(".close-area").addEventListener("mouseleave", () => {
      //   target.closest(".tab").classList.remove("is-open");
      // });
    });
  }

  topStay() {
    const videos = document.querySelectorAll(".video-hover .video");
    const triggers = document.querySelectorAll(".video-hover-trigger");
    triggers.forEach((trigger, index) => {
      trigger.addEventListener("mouseenter", () => {
        for (let i = 0; i < videos.length; i++) {
          videos[i].classList.remove("current");
        }
        videos[index].classList.add("current");
      });
    });
  }
}

export default Hover;
